import { Box, Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import RegistrarRecebimento from "./FinalizacaoOptions/RegistrarRecebimento";
import EmitirBoletoBancario from "./FinalizacaoOptions/EmitirBoletoBancario";
import TitulosSelecionados from "../CTitulosSelecionados";
import MostrarRecibo from "../../../../MostarRecibo";
import EmitirPix from "./FinalizacaoOptions/EmitirPix";
import Compensasao from "./FinalizacaoOptions/Compensacao";

export default function Step03() {

  const { watch } = useFormContext();

  const formRecb = watch('dados_recebimento.forma_recebimento')
  const recebimentoRegistrado = watch('recebimentoRegistrado')

  return (
    <>
      {
        !recebimentoRegistrado &&
        <Grid container minHeight={400} paddingTop={3} spacing={2} position="relative">
          <Grid size={{xs: 12, md: 6}} order={{ xs: 2, md: 1 }} >
            {
              formRecb === 'registrar recebimento' &&
              <RegistrarRecebimento />
            }
            {
              formRecb === 'emitir boleto bancario' &&
              <EmitirBoletoBancario />
            }
            {
              formRecb === 'compensacao' &&
              <Compensasao />
            }
            {
              formRecb === 'emitir pix' &&
              <EmitirPix />
            }
          </Grid>

          <Grid size={{xs: 12, md: 6}} order={{ xs: 1, md: 2 }}>
            <Box display="flex" justifyContent="flex-end">
              <TitulosSelecionados />
            </Box>
          </Grid>
        </Grid>
      }

      {
        recebimentoRegistrado &&
        <MostrarRecibo 
          tipoModal="Receber"
        />
      }
    </>
  )
}
